import React, { useState } from 'react';

interface Props {
  children: React.ReactNode;
}

type FeatureContextType = {
  autoAssignmentFeatureFlag: boolean;
};

export const FeatureContext = React.createContext<FeatureContextType>({
  autoAssignmentFeatureFlag: false,
});

const FeatureContextProvider: React.FC<Props> = (props) => {
  const { children } = props;
  const [features, setFeatures] = useState<FeatureContextType>({
    autoAssignmentFeatureFlag: false,
  });

  return <FeatureContext.Provider value={features}>{children}</FeatureContext.Provider>;
};

export default FeatureContextProvider;
